"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CustomerSummaryContainerAsync;

var _AsyncComponent = _interopRequireDefault(require("customer-data-ui-utilities/component/AsyncComponent"));

var _react = _interopRequireDefault(require("react"));

var _AsyncComponentErrorHandler = _interopRequireDefault(require("crm_ui/utils/AsyncComponentErrorHandler"));

function requirement(done) {
  import(
  /* webpackChunkName: "bet-CustomerSummaryContainer" */
  'BizOpsCrmUIComponents/components/customerSummary/CustomerSummaryContainer').then(function (mod) {
    return mod.default;
  }).then(done, (0, _AsyncComponentErrorHandler.default)('bet-timeline'));
}

function CustomerSummaryContainerAsync(props) {
  return _react.default.createElement(_AsyncComponent.default, {
    props: props,
    requirement: requirement
  });
}

module.exports = exports.default;